<template>
  <div class="gs-app gs-refresh-controls gv-integration-form">
    <div
      class="flex flex-col w-full"
    >
      <div
        v-if="
          typeof integrations != 'undefined' &&
          integrations.length > 0
        "
      >
        <div class="flex flex-col">
          <div class="flex flex-row-reverse w-full">
            <gd-button
              size="auto"
              primary
              class="mr-4 p-4"
              @click="showOtherIntegrationBox()"
              >{{ $t('frontend_product_step8_add_new') }}</gd-button
            >
          </div>
          <div
            v-if="
              typeof localIntegrations != 'undefined' &&
              localIntegrations.length > 0
            "
            class="mt-6"
          >
            <VuePerfectScrollbar
            style="max-height: 220px">
            <div
              v-for="(
                otherIntegration, otherIntegrationIndex
              ) in localIntegrations"
              :key="otherIntegrationIndex"
              class="flex flex-col mt-4 border-t border-grey-400 border-solid pt-4"
            >
              <div
                class="flex flex-row"
              >
                <div class="w-1/12 mr-8">
                  {{ $t('frontend_add') }} {{ $t('frontend_to') }}
                </div>
                <div class="flex flex-row w-11/12">
                  <div class="w-3/4 flex flex-col">
                    <div class="flex flex-row">
                      <div class="font-bold mr-2">
                        {{ $t('frontend_product_step8_type') }}
                      </div>
                      <div>
                        {{
                          otherIntegration.platform
                          .charAt(0)
                          .toUpperCase() +
                          otherIntegration.platform.slice(1)
                        }}
                      </div>
                    </div>
                    <div
                      v-for="(
                        otherIntegrationConfig,
                        otherIntegrationConfigIndex
                      ) in otherIntegration.config"
                      :key="otherIntegrationConfigIndex"
                      class="flex flex-row"
                    >
                      <div class="font-bold mr-2">
                        {{ otherIntegrationConfig.label }} :
                      </div>
                      <div>{{ otherIntegrationConfig.name }}</div>
                    </div>
                  </div>
                  <div class="w-1/4 flex flex-row justify-end pr-4">
                    <gd-button
                      size="icon"
                      primary
                      title="Delete Integration"
                      class="mr-2"
                      @click="
                        deleteOtherIntegration(
                          otherIntegration.id
                        )
                      "
                    >
                      <i class="fas fa-trash" />
                    </gd-button>
                  </div>
                </div>
              </div>
            </div>
            </VuePerfectScrollbar>
          </div>
          <div v-else class="my-6">
            <label class="text-grey-dark">{{
              $t('frontend_product_step8_no_integrations')
            }}</label>
          </div>
        </div>
      </div>
      <div v-else>
        <label class="text-grey-dark">{{
          $t('frontend_product_step8_no_integrations_added')
        }}</label>
      </div>
    </div>
    <gs-named-modal
      name="add-other-integration-modal"
      title="Add New Integration"
      :no-overflow="true"
    >
      <div class="gs-app gs-refresh-controls flex flex-col m-8 gv-integration-modal-body">
        <div class="flex flex-col w-full mb-6">
          <div class="w-full flex flex-col mr-2">
            <label class="font-semibold text-sm text-grey-700 mb-2">{{
              $t('frontend_product_step8_type')
            }}</label>
            <gd-dropdown
              :v-bind="integrationType"
              :value="integrationType"
              :options="integrations"
              size="full"
              @change="setValue($event)"
              @keyup="setValue($event)"
            />
          </div>
          <div
            v-if="integrationType && integrationType != ''"
            class="w-full -mx-4"
          >
            <config-menu
              :key="configMenuKey"
              :initial-values="componentConfigValues"
              :plugin-id="pluginId"
              :resources-path="resourcesPath"
              :server-path="serverPath"
              :plugin="integrationType"
              :app-data="pluginSiteData"
              layout="vertical"
              :is-dark="false"
              :show-button-borders="false"
              :show-notifications-on-save="false"
              :opened-from="'groovesell'"
              :btn-label="$t('frontend_sites_integration_modal_add_integration')"
              @update="addIntegration"
              @menu-updated="configMenuItemsUpdated"
            ></config-menu>
          </div>
        </div>
      </div>
    </gs-named-modal>
  </div>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import ConfigMenu from '@groovepages/gd-ui-kit/components/PluginMenu';
import Integration from '@/models/OtherIntegration';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'AddOtherIntegration',
  props: {
    model: {
      required: true,
    },
    integrations: {
      required: true
    },
    selectedIntegrations: {
      required: true
    },
    resourcesPath: {
      required: true,
    },
    serverPath: {
      required: true,
    },
    pluginSiteData: {
      required: true,
    },
    eventId: {
      required: true,
    },
    eventType: {
      required: true,
    },
    optinId: {},
  },
  data() {
    return {
      clearable: false,
      video: this.model,
      integrationType: '',
      configMenuKey: 1,
      integrationId: '',
      componentConfigValues: [],
      localIntegrations: this.selectedIntegrations,
      pluginId: '',
      pluginMenuItems: [],
      isEditing: false,
    };
  },

  computed: {

  },

  components: {
    Treeselect,
    ConfigMenu,
    VuePerfectScrollbar
  },

  async created() {},
  async beforeMount() {},
  methods: {
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },
    save(){

    },

    setValue(value) {
      this.integrationId = this.integrations.find(el => el.value === value).id;
      this.integrationType = value;
      this.pluginId = '';
      this.componentConfigValues = {};
      this.configMenuKey = this.configMenuKey + 1;
    },
    async addIntegrationField(integration) {
      const completeIntegrationInfo = {};
      completeIntegrationInfo.other_integration_id = this.integrationId;
      completeIntegrationInfo.optin_id = this.optinId;
      completeIntegrationInfo.event_id = this.eventId;
      completeIntegrationInfo.event_type = this.eventType;
      completeIntegrationInfo.platform = integration.platform;
      completeIntegrationInfo.config = integration.config;

      const selectedIntegration = await this.model
                          .otherIntegration()
                          .attach(completeIntegrationInfo);
                          
      this.localIntegrations.push(new Integration(selectedIntegration.data.data));
      this.$root.$emit('modal-close', 'add-other-integration-modal');
    },

    async deleteOtherIntegration(otherIntegrationId){
      this.showLoader();
      console.log('delete', otherIntegrationId,this.localIntegrations)
      // const membership = this.localIntegrations.find((m) => m.id === otherIntegrationId);
      const integration = await this.model.otherIntegration().$find(otherIntegrationId);
      const response = await integration.for(this.model).delete();
      if (
        typeof response.data !== 'undefined' &&
        typeof response.data.status !== 'undefined' &&
        response.data.status == true
      ) {
        const deletedIntegration = this.localIntegrations
            .map((item) => item.id)
            .indexOf(otherIntegrationId);
          this.localIntegrations.splice(deletedIntegration, 1);
        }
      this.hideLoader(); 

    },

    showOtherIntegrationBox() {
      this.integrationType = '';
      this.$root.$emit('modal-open', 'add-other-integration-modal');
    },

    async addIntegration(data) {
      console.log('addIntegration', data);
      const integrationConfig = data.config;
      const self = this;

      const integrationInfo = [];

      for (const index in integrationConfig) {
        const value = integrationConfig[index];

        if (value) {
          self.pluginMenuItems.forEach((menuValue, menuIndex) => {
            if (menuValue.key == index) {
              const { options } = menuValue;

              const objChecker = options.some((val) => {
                return typeof val === 'object';
              });

              let correspondingOption = value;
              if (objChecker) {
                correspondingOption = options.find((o) => o.value === value);
              }

              const singleIntegrationField = {};
              singleIntegrationField.index = index;
              singleIntegrationField.value = value;
              singleIntegrationField.label = menuValue.label;

              if (objChecker) {
                singleIntegrationField.name = correspondingOption.text;
              } else {
                singleIntegrationField.name = value;
              }

              integrationInfo.push(singleIntegrationField);
            }
          });
        }
      }

      const completeIntegrationInfo = {};
      completeIntegrationInfo.platform = this.integrationType.split('-')[0];
      completeIntegrationInfo.config = integrationInfo;
      
      await this.addIntegrationField(completeIntegrationInfo);
      this.$root.$emit('modal-close', 'add-other-integration-modal');
    },

    configMenuItemsUpdated(data) {
      console.log('configMenuItemsUpdated', data);
      this.pluginMenuItems = data.menuItems;
    },
    validate() {
      this.selectionSubmitted = true;
      return true;
    },
  },
};
</script>

<style lang="scss">
.form-setup-radio.flex {
  margin: 0;
  padding: 0;
  border: none;
  height: auto;
  position: relative;
  .ml-2 {
    margin: 0;
    label {
      color: #191d3a;
    }
    .text-grey-500 {
      font-size: 14px;
      line-height: 24px;
      color: #545671;
      margin-top: 8px;
    }
  }
  .w-6 {
    height: 24px;
    margin: 0;
    position: absolute;
    right: 0;
    top: 16px;
  }
}
</style>

<style>
.gv-integration-form { padding: 20px; border: 1px solid var(--gs-border); border-radius: var(--gs-radius-lg); background: var(--gs-surface); }
.gv-integration-modal-body { gap: 12px; max-width: 860px; }
@media (max-width: 640px) { .gv-integration-form { padding: 16px; } .gv-integration-modal-body { margin: 16px !important; } }
</style>
